// extracted by mini-css-extract-plugin
export default {"container":"list-title_container__3J0es"};